"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SyntaxHighlightingInput = void 0;
var tslib_1 = require("tslib");
// (C) 2020 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var react_codemirror2_1 = require("react-codemirror2");
var codemirror_1 = tslib_1.__importDefault(require("codemirror"));
require("codemirror/lib/codemirror.css");
require("codemirror/addon/mode/simple");
require("codemirror/addon/edit/matchbrackets");
require("codemirror/addon/display/placeholder");
var CODE_MIRROR_EOL = "\n";
var defaultOptions = {
    autofocus: false,
    lineWrapping: true,
    matchBrackets: true,
};
var findCursorIndexAcrossMultipleLines = function (text, cursorLineIndex, cursorLineCharacterIndex) {
    var getLineLengthToCursor = function (line, lineIndex) {
        if (lineIndex > cursorLineIndex) {
            return 0;
        }
        return lineIndex < cursorLineIndex ? line.length + CODE_MIRROR_EOL.length : cursorLineCharacterIndex;
    };
    return text
        .split(CODE_MIRROR_EOL)
        .map(getLineLengthToCursor)
        .reduce(function (sum, lineLength) { return sum + lineLength; }, 0);
};
/**
 * @internal
 */
exports.SyntaxHighlightingInput = function (props) {
    var value = props.value, onChange = props.onChange, onCursor = props.onCursor, formatting = props.formatting, customOptions = props.customOptions, className = props.className;
    var reportCursorPosition = function (editor) {
        if (onCursor) {
            var from = editor.getCursor("from");
            var to = editor.getCursor("to");
            var currentValue = editor.getValue();
            onCursor(findCursorIndexAcrossMultipleLines(currentValue, from.line, from.ch), findCursorIndexAcrossMultipleLines(currentValue, to.line, to.ch));
        }
    };
    var handleOnChange = function (_editor, _change, value) {
        onChange(value);
    };
    var modeOptions = formatting && {
        name: "format",
        fn: codemirror_1.default.defineSimpleMode("syntaxHighlight", formatting),
    };
    return (react_1.default.createElement(react_codemirror2_1.UnControlled, { className: classnames_1.default(className, "gd-input-syntax-highlighting-input"), value: value, defineMode: modeOptions, onChange: handleOnChange, onCursorActivity: reportCursorPosition, autoCursor: false, options: tslib_1.__assign(tslib_1.__assign({}, defaultOptions), customOptions) }));
};
//# sourceMappingURL=SyntaxHighlightingInput.js.map